var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-image"},[(_vm.lazy)?_c('van-image',{attrs:{"src":_vm.src,"lazy-load":""}}):(_vm.van)?_c('van-image',{attrs:{"src":_vm.src}}):_c('img',{attrs:{"src":_vm.src}}),_vm._v(" "),(_vm.mask || _vm.safe)?_c('div',{staticClass:"mask",class:{ dimMask: _vm.mask }}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d4a593c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/image.vue
// module id = null
// module chunks = 